import React from 'react';
import { QuantitySelector } from './QuantitySelector';
interface HeroProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  onBuyNow: () => void;
}
export function Hero({
  quantity,
  onQuantityChange,
  onBuyNow
}: HeroProps) {
  return <section className="pt-32 pb-24 px-6" data-id="element-74">
      <div className="max-w-5xl mx-auto" data-id="element-75">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-76">
          {/* Left: Product Info */}
          <div className="space-y-8" data-id="element-77">
            <div className="space-y-4" data-id="element-78">
              <h1 className="text-5xl md:text-6xl font-light tracking-tight" data-id="element-79">
                The Candle
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed font-light" data-id="element-80">
                A smoked pine, hand-poured glass candle crafted in England using
                food-grade soy wax. Clean burn, 65-hour lifespan, and a premium
                gloss-black vessel that fits any modern interior.
              </p>
            </div>

            <div className="space-y-6" data-id="element-81">
              <div className="text-3xl font-medium" data-id="element-82">£65</div>
              <QuantitySelector quantity={quantity} onQuantityChange={onQuantityChange} data-id="element-83" />
              <button onClick={onBuyNow} className="w-full md:w-auto px-12 py-4 bg-black text-white text-sm tracking-wider hover:bg-gray-800 transition-colors" data-id="element-84">
                Buy now
              </button>
            </div>
          </div>

          {/* Right: Product Image */}
          <div className="aspect-[3/4] overflow-hidden" data-id="element-85">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYWdgvMBrbBgwnb6VpycWJ/IMG_5899.jpg" alt="The Candle - Smoked Pine in gloss black glass vessel" className="w-full h-full object-cover" data-id="element-86" />
          </div>
        </div>
      </div>
    </section>;
}